import { useLazyQuery } from '@apollo/client'
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'

import {
  buildFeatureSet,
  getCredentials,
  hasRequiredFeatures
} from '../../cache/auth'
import PageHeader from '../../components/PageHeader'
import { FileStatus, ImageProps } from '../../components/UploadBox/ImageBox'
import { UploadBox } from '../../components/UploadBox/index'
import { ACCOMMODATION_IMAGES_QUERY } from '../../graphql/upload'
import accommodationPagesRoleManagement from '../../staticRoleManagement/accommodationsRoleManagement'
import { Image } from '../../types/image'

interface UploadBoxForAccommodationProps {
  title: string
}

export const UploadBoxForAccommodation: React.FC<
  UploadBoxForAccommodationProps
> = ({ title }) => {
  const [images, setImages] = useState<ImageProps[]>([])
  const params = useParams<{
    accID: string
    propertyCode: string
  }>()

  const [getImages, { data, loading }] = useLazyQuery<{
    accommodationImages: Image[]
  }>(ACCOMMODATION_IMAGES_QUERY, {
    fetchPolicy: 'network-only'
  })

  useEffect(() => {
    getImages({
      variables: {
        propertyCode: params.propertyCode
      }
    })
  }, [])
  useEffect(() => {
    if (data) {
      let newImages: ImageProps[] = []

      newImages = data.accommodationImages.map((singleImage: Image) => ({
        fileURL: singleImage.url,
        status: FileStatus.COMPLETED,
        fileName: singleImage.name,
        fileSize: singleImage.size,
        mediaID: singleImage.id
      }))

      setImages(newImages)
    }
  }, [loading, data])

  const credentials = getCredentials()
  const featureSet = buildFeatureSet(credentials)

  const hasAccessToUploadImage = hasRequiredFeatures(
    accommodationPagesRoleManagement
      .find(
        (item) => item.route === '/accommodations/:accID/:propertyCode/:page'
      )
      ?.tabs?.find((tabItem) => tabItem.params.page === 'images')
      ?.requiredFeatures,
    featureSet
  )

  return (
    <>
      <PageHeader title={title} />
      <UploadBox
        hasAccess={hasAccessToUploadImage}
        loading={loading}
        entityCode={params.propertyCode}
        entityid={params.accID}
        entityType={'Accommodation'}
        images={images}
        setImages={setImages}
        imageType={'Image'}
      />
    </>
  )
}
